/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHexagonNumber4 = createReactComponent("hexagon-number-4", "IconHexagonNumber4", [
  [
    "path",
    {
      d: "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 8v3a1 1 0 0 0 1 1h3", key: "svg-1" }],
  ["path", { d: "M14 8v8", key: "svg-2" }]
]);

export { IconHexagonNumber4 as default };
//# sourceMappingURL=IconHexagonNumber4.js.map
